export const REDIRECT_AFTER_MS = 5000;
